export const LAYOUT_MOUNTED = 'reports/layout/LAYOUT_MOUNTED'
